import { useNavigate } from "react-router-dom";

import { Appointment } from "0.Mine/0.Components/BusinessCard/EventCalendar/mockData";
import { AppointmentData } from "0.Mine/0.Components/CRM/Customers/BookingCalendar";
import { useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

import { Event } from "../../3.Interfaces/Event";
import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

export const useHandleCalendar = () => {
  const { QlickUpAPI } = useQlickupAPI();
  const { session } = useSession();
  const navigate = useNavigate();
  if (!session) {
    navigate("/signin", { replace: true });
  }
  const userid = session?.user?.id;
  const token = session?.user?.token;

  const getAllCalendarEvents = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getallEvents",
        null,
        "calendarevent",
        QlickupActions.GET
      );
      console.log(response);
      if (response.success) {
        return response.events as Event[];
      } else {
        return [];
      }
    } catch (exception) {
      console.error(exception);
      return [];
    }
  };
  const createCalendarEvent = async (event: Event, businessId: number) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      data: JSON.stringify(event),
      action: "createCalendarEvent",
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/calendarevent.php?${queryString}`);

      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteCalendarEvent = async (eventId: number, businessId: number) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      data: eventId,
      action: "deletecalendarevent",
    };
    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`DELETE/calendarevent.php?${queryString}`);

      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const editCalendarEvent = async (eventId: number, event: Event, businessId: number) => {
    if (isNaN(eventId) || eventId <= 0) {
      throw new Error("Invalid event ID");
    }

    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      eventId: eventId,
      data: JSON.stringify({
        ...event,
        id: eventId,
      }),
      action: "editCalendarEvent",
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/calendarevent.php?${queryString}`);
      if (response.data?.error) {
        throw new Error(response.data.error);
      }

      return response;
    } catch (error) {
      throw error;
    }
  };

  const getVendorCalendarEvents = async (businessId: number, vendorId: number) => {
    try {
      const additionalParams: AdditionalParams = {
        vendorId: vendorId.toString(),
      };

      const response = await QlickUpAPI(
        businessId.toString(),
        "getSingleCalendar",
        null,
        "calendarevent",
        QlickupActions.GET,
        additionalParams
      );

      console.log(response);

      if (response.success) {
        return response.events as Event[];
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getStaffCalendar = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getStaffEvents",
        null,
        "calendarevent",
        QlickupActions.GET,
        null
      );

      if (response.success) {
        return response.events as AppointmentData[];
      }
    } catch (error) {
      return null;
    }
  };

  const sendEventToVendor = async (businessId: number, vendorId: number, event: Event) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "sendEventToVendor",
        event,
        "calendarevent",
        QlickupActions.POST,
        { vendorId: vendorId.toString() }
      );
    } catch (error) {
      console.error(error);
    }
  };

  return {
    createCalendarEvent,
    editCalendarEvent,
    deleteCalendarEvent,
    getAllCalendarEvents,
    getVendorCalendarEvents,
    getStaffCalendar,
    sendEventToVendor,
  };
};
